import { Box } from '@material-ui/core'
import React, { PropsWithChildren } from 'react'

export function TabContent({ children }: PropsWithChildren<{}>) {
  return <Box className="h-100">{children}</Box>
}
